/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientNutritionPlan from './patient-nutrition-plan';
import PatientNutritionPlanDetail from './patient-nutrition-plan-detail';
import PatientNutritionPlanUpdate from './patient-nutrition-plan-update';
import PatientNutritionPlanDeleteDialog from './patient-nutrition-plan-delete-dialog';

const PatientNutritionPlanRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientNutritionPlan />} />
    <Route path="new" element={<PatientNutritionPlanUpdate />} />
    <Route path=":id">
      <Route index element={<PatientNutritionPlanDetail />} />
      <Route path="edit" element={<PatientNutritionPlanUpdate />} />
      <Route path="delete" element={<PatientNutritionPlanDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientNutritionPlanRoutes;
